import { Box, Chip, Tooltip } from '@mui/material';
import React from 'react';

import { CollectionTags } from '../../../Types/enums';

type TagSummaryChipsProps = {
  tags: string[];
  omitVerified?: boolean;
  onRemoveTag?: (tag: string) => void;
};

const TagSummaryChips: React.FC<TagSummaryChipsProps> = ({ tags, omitVerified, onRemoveTag }) => {
  if (tags.length === 0) return null;

  const visibleTags = omitVerified ? tags.filter((tag) => tag !== CollectionTags.VERIFIED) : tags;

  if (visibleTags.length === 0) return null;

  const firstVisibleTag = visibleTags[0];
  const remainingTags = tags.filter((tag) => tag !== firstVisibleTag);

  const firstTagChip = (
    <Chip
      label={firstVisibleTag}
      key={firstVisibleTag}
      size="small"
      onDelete={onRemoveTag ? () => onRemoveTag(firstVisibleTag) : undefined}
      sx={{
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    />
  );

  const moreChip =
    remainingTags.length > 0 ? (
      <Tooltip
        arrow
        title={
          <div>
            {remainingTags.map((tag) => (
              <div key={tag}>{tag}</div>
            ))}
          </div>
        }
      >
        <Chip
          label={`+${remainingTags.length} more`}
          key="more-count"
          size="small"
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'pointer',
          }}
        />
      </Tooltip>
    ) : null;

  return <Box sx={{ display: 'flex', gap: 1 }}>{[firstTagChip, moreChip].filter(Boolean)}</Box>;
};

export default TagSummaryChips;
